/**
 * @mui/utils v9.3.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { default as chainPropTypes } from "./chainPropTypes/index.mjs";
export { default as deepmerge } from "./deepmerge/index.mjs";
export { isPlainObject } from "./deepmerge/index.mjs";
export { default as elementAcceptingRef } from "./elementAcceptingRef/index.mjs";
export { default as elementTypeAcceptingRef } from "./elementTypeAcceptingRef/index.mjs";
export { default as exactProp } from "./exactProp/index.mjs";
export { default as formatMuiErrorMessage } from "./formatMuiErrorMessage/index.mjs";
export { default as unstable_contains } from "./contains/index.mjs";
export { default as unstable_getActiveElement } from "./getActiveElement/index.mjs";
export { default as unstable_getEventTarget } from "./getEventTarget/index.mjs";
export { default as getDisplayName } from "./getDisplayName/index.mjs";
export { default as HTMLElementType } from "./HTMLElementType/index.mjs";
export { default as ponyfillGlobal } from "./ponyfillGlobal/index.mjs";
export { default as refType } from "./refType/index.mjs";
export { default as unstable_capitalize } from "./capitalize/index.mjs";
export { default as unstable_createChainedFunction } from "./createChainedFunction/index.mjs";
export { default as unstable_debounce } from "./debounce/index.mjs";
export { default as unstable_deprecatedPropType } from "./deprecatedPropType/index.mjs";
export { default as unstable_fastDeepAssign } from "./fastDeepAssign/index.mjs";
export { default as unstable_fastObjectShallowCompare } from "./fastObjectShallowCompare/index.mjs";
export { default as unstable_isObjectEmpty } from "./isObjectEmpty/index.mjs";
export { default as unstable_isMuiElement } from "./isMuiElement/index.mjs";
export { default as unstable_ownerDocument } from "./ownerDocument/index.mjs";
export { default as unstable_ownerWindow } from "./ownerWindow/index.mjs";
export { default as unstable_requirePropFactory } from "./requirePropFactory/index.mjs";
export { default as unstable_setRef } from "./setRef/index.mjs";
export { default as unstable_useEnhancedEffect } from "./useEnhancedEffect/index.mjs";
export { default as unstable_useId } from "./useId/index.mjs";
export { default as unstable_unsupportedProp } from "./unsupportedProp/index.mjs";
export { default as unstable_useControlled } from "./useControlled/index.mjs";
export { default as unstable_useEventCallback } from "./useEventCallback/index.mjs";
export { default as unstable_useForkRef } from "./useForkRef/index.mjs";
export { default as unstable_useLazyRef } from "./useLazyRef/index.mjs";
export { default as unstable_useTimeout, Timeout as unstable_Timeout } from "./useTimeout/index.mjs";
export { default as unstable_useOnMount } from "./useOnMount/index.mjs";
export { default as unstable_useIsFocusVisible } from "./useIsFocusVisible/index.mjs";
export { default as unstable_useForcedRerendering } from "./useForcedRerendering/index.mjs";
export { default as unstable_useValueAsRef } from "./useValueAsRef/index.mjs";
export { default as unstable_isFocusVisible } from "./isFocusVisible/index.mjs";
export { default as unstable_getScrollbarSize } from "./getScrollbarSize/index.mjs";
export { default as usePreviousProps } from "./usePreviousProps/index.mjs";
export { default as getValidReactChildren } from "./getValidReactChildren/index.mjs";
export { default as visuallyHidden } from "./visuallyHidden/index.mjs";
export { default as integerPropType } from "./integerPropType/index.mjs";
export { default as internal_resolveProps } from "./resolveProps/index.mjs";
export { default as unstable_composeClasses } from "./composeClasses/index.mjs";
export { default as unstable_generateUtilityClass } from "./generateUtilityClass/index.mjs";
export { isGlobalState as unstable_isGlobalState } from "./generateUtilityClass/index.mjs";
export * from "./generateUtilityClass/index.mjs";
export { default as unstable_generateUtilityClasses } from "./generateUtilityClasses/index.mjs";
export { default as unstable_ClassNameGenerator } from "./ClassNameGenerator/index.mjs";
export { default as clamp } from "./clamp/index.mjs";
export { default as unstable_useSlotProps } from "./useSlotProps/index.mjs";
export { default as unstable_resolveComponentProps } from "./resolveComponentProps/index.mjs";
export { default as unstable_extractEventHandlers } from "./extractEventHandlers/index.mjs";
export { default as unstable_getReactNodeRef } from "./getReactNodeRef/index.mjs";
export { default as unstable_getReactElementRef } from "./getReactElementRef/index.mjs";
export { default as isEventHandler } from "./isEventHandler/index.mjs";
export * from "./types/index.mjs";